import React from 'react'

const DownArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20.346" height="12.563"><path d="M2.391 0l7.782 7.765L17.955 0l2.391 2.391-10.173 10.172L0 2.391z" fill="currentColor"/></svg>
)

export default DownArrow